<template>
	<div class="claims p-4 md:p-6">
		<!-- <ViewClaim /> -->
		<ReportIncident />
		<ReportClaim />

		<div class="w-full">
			<!-- Header -->
			<div class="mb-8">
				<h1 class="text-2xl md:text-3xl font-bold text-text-primary">
					Claims Dashboard
				</h1>
			</div>

			<!-- Quick Actions Section -->
			<div class="mb-8">
				<h2 class="text-lg font-semibold text-text-primary mb-4">
					Quick Actions
				</h2>
				<div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
					<div
						class="bg-primary hover:bg-primary-light text-white rounded-lg p-6 cursor-pointer transition-colors duration-200 flex items-center gap-4"
						@click="handleReportIncident"
					>
						<i class="fa fa-receipt text-3xl"></i>
						<span class="font-semibold text-sm uppercase"
							>Report Incident</span
						>
					</div>
					<div
						class="bg-green-600 hover:bg-green-700 text-white rounded-lg p-6 cursor-pointer transition-colors duration-200 flex items-center gap-4"
						@click="$store.commit('showReportClaim', true)"
					>
						<i class="fa fa-file-invoice-dollar text-3xl"></i>
						<span class="font-semibold text-sm uppercase"
							>Report Claim</span
						>
					</div>
				</div>
			</div>

			<!-- <div class="summary-box">
         <div class="row">
            <div class="col-lg-4" v-for="(summary,i) in summaries" :key="i">
               <div class="card card-details summary-card">
                  <div class="num">{{summary.summary_value}}</div>
                  <div class="txt">{{summary.summary_name}}</div>
               </div>
            </div>
         </div>
      </div>

      <div class="scroll-content" v-if="allClaims.length > 0">
         <scrollbar>
            <div class="row">
               <div class="col-12" v-for="(claim,index) in allClaims" :key="index">
                  <Claim :claim="claim" @view-claim="viewClaim({claim})"/>
               </div>
            </div>
         </scrollbar>
      </div> -->

			<!-- Claims List with New Cards -->
			<div v-if="dummyClaims && dummyClaims.length > 0">
				<h2 class="text-lg font-semibold text-text-primary mb-4">
					List of Claims
				</h2>
				<div
					class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4"
				>
					<ClaimCard
						v-for="(claim, index) in dummyClaims"
						:key="index"
						:claim="claim"
						@view-claim="handleViewClaim"
					/>
				</div>
			</div>

			<!-- No Claims Message -->
			<div v-else class="max-w-md mx-auto">
				<div
					class="bg-white rounded border border-gray-200 p-10 text-center"
				>
					<p class="text-sm font-semibold text-accent">
						No Claims Available
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import claim from '../rsc/stores/claims.store';
import VueScrollbar from 'vue-scrollbar-simple';

export default {
	beforeCreate() {
		Event.$emit('loader:show', true);
	},
	beforeDestroy() {
		this.$store.unregisterModule('claim');
	},
	created() {
		utils.registerModule('claim', claim, this.$store);
	},
	data() {
		return {
			dummyClaims: [
				{
					id: 'CLM-2026-001',
					type: 'Vehicle Accident',
					date: 'Jan 10, 2026',
					status: 'In Review',
					amount: 2450.0,
				},
				{
					id: 'CLM-2026-002',
					type: 'Property Damage',
					date: 'Jan 8, 2026',
					status: 'Approved',
					amount: 1850.5,
				},
				{
					id: 'CLM-2026-003',
					type: 'Vehicle Accident',
					date: 'Jan 10, 2026',
					status: 'In Review',
					amount: 2450.0,
				},
			],
		};
	},
	components: {
		Advert: () => import('../templates/ads/advert'),
		Claim: () => import('../templates/others/claim'),
		ClaimCard: () => import('../templates/others/claim-card'),
		ViewClaim: () => import('../templates/others/view-claim'),
		ReportIncident: () => import('../templates/others/report-incident'),
		ReportClaim: () => import('../templates/others/report-claim'),
		scrollbar: VueScrollbar,
	},
	computed: {
		...mapGetters([
			'allClaims',
			'showClaimsModal',
			'summaries',
			'selectedClaim',
		]),
	},
	methods: {
		...mapActions(['fetchData', 'viewClaim']),
		handleReportIncident() {
			this.$store.commit('showReportIncident', true);
		},
		handleViewClaim(claim) {
			this.$router.push({
				name: 'ViewClaim',
				params: { id: claim.id },
			});
		},
	},
	mounted() {
		// utils.registerModule('claim',claim,this.$store)
		// this.fetchData()
	},
};
</script>

<style lang="less">
.claims {
	.white-content {
		background: var(--white);
		border-radius: 4px;
		border: solid 1px #e6eaee;
		padding: 40px 0;
		text-align: center;
		font-size: 14px;
		font-weight: 600;
		color: var(--ne-red);
	}

	.summary-box {
		margin: 15px 0;

		.summary-card {
			padding: 10px;
			text-align: center;
			margin: 5px 0;

			.num {
				font-size: 32px;
				font-family: var(--font-bolder);
			}
			.txt {
				font-weight: 600;
				margin: 3px 0 0 0;
				font-size: 13px;
				text-transform: uppercase;
			}
		}
	}
	.action-card {
		padding: 20px 30px;
		cursor: pointer;
		margin: 5px 0;

		i {
			font-size: 32px;
		}
		.txt {
			font-weight: 600;
			margin: 7px 0 0 20px;
			font-size: 13px;
			text-transform: uppercase;
		}
	}
	.scroll-content {
		height: calc(100vh - 230px);

		.row {
			margin: 0 !important;
		}
		.col-12 {
			margin: 0 !important;
		}
	}
}
</style>
